import { WatchList, WatchlistPermission } from './types'

export const ALL_WATCHLIST_LABEL = 'All'
export const MINE_WATCHLIST_LABEL = 'Mine'

export const getPermissionForResponse = (
  response: number
): WatchlistPermission => (response === 0 ? 'private' : 'myFirm')

export const getResponseForPermission = (permission: WatchlistPermission) =>
  permission.toLowerCase() === 'private' ? 0 : 1

export const watchlistDetailsFromResponse = <T extends WatchList>(
  response: any
): T => ({
  ...response,
  permission: getPermissionForResponse(response.permission)
})
